import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import CampaignSection from './components/CampaignSection';
import CampaignFlow from './components/CampaignFlow';
import DashboardSection from './components/DashboardSection';
import AdOrderSection from './components/AdOrderSection';
import ComparisonSection from './components/ComparisonSection';
import LeadSection from './components/LeadSection';
import FinalCTA from './components/FinalCTA';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import LeadPopup from './components/LeadPopup';
import FloatingWhatsApp from './components/FloatingWhatsApp';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navbar />
      <HeroSection />
      <HowItWorks />
      <CampaignSection />
      <CampaignFlow />
      <DashboardSection />
      <AdOrderSection />
      <ComparisonSection />
      <LeadSection />
      <FinalCTA />
      <ContactSection />
      <Footer />
      <LeadPopup />
      <FloatingWhatsApp />
    </div>
  );
}
